import React from 'react';

const JobDuration = ({
  width = 16,
  height = 16,
  className,
  color,
  ...rest
}) => {
  return (
    <svg
      role="presentation"
      aria-hidden="true"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      {...rest}
    >
      <path
        d="M13.0664 4.00049V2.40062V2.40062C13.0664 2.10609 12.8276 1.86723 12.5331 1.86729V1.86729H2.39974V1.86729C2.10519 1.86729 1.86641 2.10607 1.86641 2.40062V2.40062V12.534V12.534C1.86641 12.8285 2.10519 13.0673 2.39974 13.0673V13.0673L3.99951 13.0673"
        stroke="#6E7781"
        stroke-width="1.25"
        stroke-linecap="round"
      />
      <g clip-path="url(#clip0_10009_134878)">
        <path
          d="M10.6671 8.29473V10.6651L12.0893 12.0873M10.6671 14.9318C8.31064 14.9318 6.40039 13.0215 6.40039 10.6651C6.40039 8.30869 8.31064 6.39844 10.6671 6.39844C13.0235 6.39844 14.9337 8.30869 14.9337 10.6651C14.9337 13.0215 13.0235 14.9318 10.6671 14.9318Z"
          stroke="#6E7781"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10009_134878">
          <rect
            width="10.6667"
            height="10.6667"
            fill="white"
            transform="translate(5.33398 5.33203)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export { JobDuration };
